(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ProductLineDetailController', ProductLineDetailController);

    ProductLineDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProductLine', 'Company'];

    function ProductLineDetailController($scope, $rootScope, $stateParams, previousState, entity, ProductLine, Company) {
        var vm = this;

        vm.productLine = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('abcQualityMatchApp:productLineUpdate', function(event, result) {
            vm.productLine = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
